import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/common.css';
require("./assets/js/px2rem.js")
Vue.config.productionTip = false
import { get, post } from "./assets/js/axios";
Vue.prototype.$http = {
  get,
  post
};
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
